import type { GridBlockData } from "~/core";

export const isGridBlock = (item: unknown): item is GridBlockData => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "grid_block"
  );
};
